import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6ceab16a")
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "label-option-desc" }, "W", -1)
const _hoisted_3 = { id: "size-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "label-option-desc" }, "H", -1)
const _hoisted_7 = { id: "size-info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.idxRef === 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          id: "custom-size-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCustomLabelSizesWidth && _ctx.showCustomLabelSizesWidth(...args))),
          disabled: _ctx.isDisabled
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.currentLabel.width) + " ", 1),
            _hoisted_4
          ])
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          id: "custom-size-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCustomLabelSizesHeight && _ctx.showCustomLabelSizesHeight(...args))),
          disabled: _ctx.isDisabled
        }, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.currentLabel.height) + " ", 1),
            _hoisted_8
          ])
        ], 8, _hoisted_5))
  ]))
}